
import {
  IVerifikation,
  VerifikationStatus,
} from '../../Queries/VerifikationQuery/VerifikationQuery';
import EDTooltip from '../../../../../../../../../BaseComponents/Tooltip/EDTooltip';
import EDIcon, {
  IconColor,
} from '../../../../../../../../../BaseComponents/Icon/EDIcon';

interface IProps {
  verifikation: IVerifikation;
}

export const VerifikationStatusMark: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const { verifikation } = props;

  const titleIconTitle = verifikation?.backad
    ? 'Verifikationen (eller journalen) är backad'
    : verifikation?.info?.status.value === VerifikationStatus.SKAPAD
    ? 'Inte definitivbokförd'
    : 'Definitivbokningen ändrad - se kopplade verifikationer';

  const iconColor: IconColor | undefined =
    (verifikation?.harAndringsVerifikation && !verifikation.backad) ||
    verifikation?.info?.status.value === VerifikationStatus.SKAPAD
      ? 'warning'
      : verifikation?.backad
      ? 'error'
      : undefined;

  return (
    <EDTooltip title={titleIconTitle} placement="right-end">
      <span>
        <EDIcon
          paddingLeft={1}
          color={iconColor}
          size="small"
          iconType="circle"
        />
      </span>
    </EDTooltip>
  );
};

export default VerifikationStatusMark;
